import {Block, Space, Typography} from "@bezlimit/bezlimit-ui";
import _ from "lodash";
import React, {useContext} from "react";
import {useTranslation} from "react-i18next";
import NumberFormat from "react-number-format";
import {LayoutContext} from "../../../core/Contexts";
import "./style.scss";
// forms
import FormOutputBonuses from "../../forms/outputOfBalanceBonuses";
// services
import BonusesService from "../../../services/BonusesService";

export default React.memo(function OutputOfBalanceBonuses() {
    const contextLayout = useContext(LayoutContext);
    const {t} = useTranslation();
    return (
        <Typography
            as="div"
            className="bl-replenishment-balanse-bonuses bl-replenishment-balanse-bonuses-output"
        >
            <Space
                size={_.gte(contextLayout?.width ?? 0, 768) ? 24 : 24}
                direction="vertical"
                align="center"
            >
                <Typography as="div">
                    <Space size={16} direction="vertical" align="center">
                        <Typography
                            size={_.gte(contextLayout?.width ?? 0, 768) ? 24 : 17}
                            level={2}
                            color="#000000"
                        >
                            {t("Вывод бонусов")}
                        </Typography>
                        <Typography color="#828282" className="subtitle">
                            {" "}
                            {t("Вывод бонусов на баланс банковской карты")}{" "}
                        </Typography>
                        <Block>
                            <Space direction="vertical">
                                <Typography size={12} fontFamily="hauss" color="#CFC8DB">
                                    {t("Бонусы доступные для списания")}
                                </Typography>
                                <Typography as="div" size={24} fontFamily="alumna">
                                    <NumberFormat
                                        className="format-accumulated-sum"
                                        thousandSeparator=" "
                                        displayType="text"
                                        value={BonusesService.accumulated.toFixed(2)}
                                    />
                                </Typography>
                            </Space>
                        </Block>
                    </Space>
                </Typography>
                <FormOutputBonuses />
            </Space>
        </Typography>
    );
});
